export default __webpack_public_path__ + "static/media/six.6032bcd7.mp3";